<div class="main-content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header card-header-danger">
            <h4 class="card-title">Branches</h4>
          </div>
          <div class="card-body">
            <form [formGroup]="AddBranchForm">
              <div class="row">
                <div class="col-md-5">
                  <mat-form-field class="example-full-width">
                    <input matInput placeholder="Branch Name" formControlName="BranchName">
                    <!-- <mat-error *ngIf="BranchName.hasError('required')">
            Company Name is <strong>required</strong>
          </mat-error> -->
                  </mat-form-field>

                </div>
                <div class="col-md-3">
                  <mat-form-field class="example-full-width">
                    <input matInput placeholder="Address" formControlName="Address">
                    <!-- <mat-error *ngIf="Address.hasError('required')">
            Username is <strong>required</strong>
          </mat-error> -->
                  </mat-form-field>

                </div>
                <div class="col-md-4">
                  <mat-form-field class="example-full-width">
                    <input matInput  placeholder="Branch Phone" type="tel" formControlName="Phone">
                    <!-- <mat-error *ngIf="Phone.hasError('Phone') && !Phone.hasError('required')">
            Please enter a valid email address
          </mat-error>
          <mat-error *ngIf="Phone.hasError('required')">
            Email is <strong>required</strong>
          </mat-error> -->
                  </mat-form-field>
                </div>
              </div>
              <button mat-raised-button type="submit" *ngIf="!editmode" class="btn primary pull-right"
                [disabled]="AddBranchForm.invalid" (click)="addbranch()">Add Branch</button>
              <button mat-raised-button type="submit" *ngIf="editmode" class="btn primary pull-right"
                (click)="UpdateBranch()">Save</button>
              <div class="clearfix"></div>
            </form>
            <!-- <mat-form-field class="mt-5">
    <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter">
  </mat-form-field> -->
            <br>
            <table mat-table [dataSource]="clients" class="mat-elevation-z8">

              <!-- Position Column -->
              <ng-container matColumnDef="BranchName">
                <th mat-header-cell *matHeaderCellDef> Branch Name </th>
                <td mat-cell *matCellDef="let element"> {{element.name}} </td>
              </ng-container>

              <!-- Name Column -->
              <ng-container matColumnDef="Adress">
                <th mat-header-cell *matHeaderCellDef> Adress </th>
                <td mat-cell *matCellDef="let element"> {{element.address}} </td>
              </ng-container>

              <!-- Weight Column -->
              <ng-container matColumnDef="BranchPhone">
                <th mat-header-cell *matHeaderCellDef> Branch Phone </th>
                <td mat-cell *matCellDef="let element"> {{element.phonenumber}} </td>
              </ng-container>
              <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef> Action </th>
                <td mat-cell *matCellDef="let element">
                  <button mat-raised-button (click)="Edit(element)"><i class="material-icons">
                      edit
                    </i></button>
                  <button mat-raised-button (click)="DeleteBranch(element)"><i class="material-icons">
                      delete
                    </i></button>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>